import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionDayTripPlanStockTarget } from "./stock-target";
import { QuestionDayTripPlanStockTerm } from "./stock-term";

import type { DayTripPlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	stock: DayTripPlanCategoriesAndManagerStore["stock"];
};

export const QuestionDayTripPlanStock = ({ stock }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="在庫設定" categoryStore={stock}>
			<QuestionDayTripPlanStockTarget />
			<QuestionDayTripPlanStockTerm />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionDayTripPlanStock.displayName = "QuestionDayTripPlanStock";
